var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle84(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 172,
    viewBox: "0 0 283 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 55C0 24.6244 24.6243 0 55 0H228C258.376 0 283 24.6243 283 55V171.833C283 171.833 241.289 103.805 140.27 140.012C39.2499 176.219 0 171.833 0 171.833V55Z",
    fill: "#2774C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle84);
export default __webpack_public_path__ + "static/media/Rectangle 84.417b61e93d84e209275b5adc94033099.svg";
export { ForwardRef as ReactComponent };